import apiApp from "./index";
const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

const constructHeaders = (extraHeaders = {}) => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": `${decodedToken?.tenantApiKey}`,
  };

  if (
    decodedToken?.roles?.includes("TENANT_ADMIN") &&
    decodedToken?.subTenantId === undefined
  ) {
    headers["tenant-login"] = true;
  }

  // merge additional headers passed at call time
  return { ...headers, ...extraHeaders };
};

const UserContactApi = {
  // Create Contacts Api
  CreateContactsApi: (data) => {
    const subTenantIds = decodedToken?.subTenantIds?.split(',');

    if (subTenantIds) {
      const jsonData = JSON.parse(data);
      jsonData.subTenantDTO = { id: subTenantIds[0] };
      data = JSON.stringify(jsonData);
    }

    const headers = {
      Authorization: `Bearer ${token}`,
      "x-Authorization": `${decodedToken?.tenantApiKey}`,
    };
    return new Promise((resolve, reject) => {
      apiApp
        .post(`/user-contacts`, data, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  // OTP OTPResent Api
  OTPResent: (data) => {
    const subTenantIds = decodedToken?.subTenantIds?.split(',');

    if (subTenantIds) {
      const jsonData = JSON.parse(data);
      jsonData.subTenantDTO = { id: subTenantIds[0] };
      data = JSON.stringify(jsonData);
    }

    const headers = {
      Authorization: `Bearer ${token}`,
      "x-Authorization": `${decodedToken?.tenantApiKey}`,
    };
    return new Promise((resolve, reject) => {
      apiApp
        .post(`/user/resend-otp`, data, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  // OTP Valid Contacts Api
  OTPValid: (data) => {
    const subTenantIds = decodedToken?.subTenantIds?.split(',');

    if (subTenantIds) {
      const jsonData = JSON.parse(data);
      jsonData.subTenantDTO = { id: subTenantIds[0] };
      data = JSON.stringify(jsonData);
    }

    const headers = {
      Authorization: `Bearer ${token}`,
      "x-Authorization": `${decodedToken?.tenantApiKey}`,
    };
    return new Promise((resolve, reject) => {
      apiApp
        .post(`/user/otp-verifications`, data, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  // Put Contacts Api
  PutContactsApi: (ContactsiID, data) => {
    const subTenantIds = decodedToken?.subTenantIds?.split(',');

    if (subTenantIds) {
      const jsonData = JSON.parse(data);
      jsonData.subTenantDTO = { id: subTenantIds[0] };
      data = JSON.stringify(jsonData);
    }

    const headers = {
      Authorization: `Bearer ${token}`,
      "x-Authorization": `${decodedToken?.tenantApiKey}`,
    };
    return new Promise((resolve, reject) => {
      apiApp
        .put(`/user-contacts/${ContactsiID}`, data, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },
  // List User Contact Api
  ListUserContactApi: () => {
    const headers = constructHeaders();
    return new Promise((resolve, reject) => {
      apiApp
        .get(`/user-contacts?size=100&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`, {
          headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  // Single Contacts Api
  SingleContactsApi: (ContactsiID) => {
    const headers = {
      Authorization: `Bearer ${token}`,
      "x-Authorization": `${decodedToken?.tenantApiKey}`,
    };
    return new Promise((resolve, reject) => {
      apiApp
        .get(
          `/user-contacts/${ContactsiID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
          {
            headers: headers,
          }
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  // Delete Contacts Api
  DeleteContactsApi: (ContactsiID) => {
    const headers = constructHeaders();
    // const headers = {
    //   Authorization: `Bearer ${token}`,
    //   "x-Authorization": `${decodedToken?.tenantApiKey}`,
    // };
    return new Promise((resolve, reject) => {
      apiApp
        .delete(
          `/user-contacts/${ContactsiID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
          {
            headers,
          }
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },
};

export default UserContactApi;
